import logo from "../assets/icons/iK Brand Mark.svg"
import { useMediaQuery, Box, Typography } from "@mui/material"
import { theme } from "@ikhokha/commons-ui"
import { ThemeProvider } from "@emotion/react"
export default function Logo({ hasHeading = false }: { hasHeading?: boolean }) {
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"))
	return (
		<ThemeProvider theme={theme}>
			<Box>
				<img src={logo} alt="logo" />
				{isSmallScreen ? (
					<Box sx={{ color: "#3F3E38", marginTop: theme.spacing(1) }}>
						{hasHeading && (
							<Typography variant="body1" component="body">
								Join the iK Tribe today!
							</Typography>
						)}
					</Box>
				) : (
					<></>
				)}
			</Box>
		</ThemeProvider>
	)
}
